import { useEffect, useState } from 'react';
import {
  featureFlags,
  type FeatureFlagName,
  type FeatureFlags,
} from './featureFlags';

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState<FeatureFlags>(featureFlags.getAllFlags());

  useEffect(() => {
    const handleFlagChange = (event: CustomEvent) => {
      setFlags(event.detail);
    };

    window.addEventListener(
      'featureFlagsChanged',
      handleFlagChange as EventListener,
    );

    return () => {
      window.removeEventListener(
        'featureFlagsChanged',
        handleFlagChange as EventListener,
      );
    };
  }, []);

  const isEnabled = (flag: FeatureFlagName): boolean => {
    return Boolean(flags[flag]);
  };

  return {
    flags,
    isEnabled,
  };
};
